import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { RiskResponse } from 'src/app/models/risk-response.model'

@Injectable({
  providedIn: 'root',
})
export class RiskService {
  public static readonly riskEndpoint = '/risk'

  constructor(private readonly http: HttpClient) {}

  getRisk(fundId: string): Observable<RiskResponse> {
    return this.http.get<RiskResponse>(
      `vmf/api/${fundId}`.concat(RiskService.riskEndpoint),
    )
  }
}
